const SLUG_SUFFIX = "-service-near-me";

/**
 * Convert a string to a URL-safe slug.
 * e.g. "AC Mechanic" → "ac-mechanic", "Electrical Services" → "electrical-services"
 */
export function slugify(text) {
  if (!text || typeof text !== "string") return "";
  return text
    .trim()
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

/**
 * Slug for URL - appends "-service-near-me".
 * e.g. "AC Mechanic" → "ac-mechanic-service-near-me"
 */
export function slugifyForUrl(text) {
  const base = slugify(text);
  return base ? `${base}${SLUG_SUFFIX}` : "";
}

/**
 * Strip "-service-near-me" from slug for matching.
 * e.g. "ac-mechanic-service-near-me" → "ac-mechanic"
 */
export function slugToMatch(slug) {
  if (!slug || typeof slug !== "string") return "";
  return slug.endsWith(SLUG_SUFFIX) ? slug.slice(0, -SLUG_SUFFIX.length) : slug;
}
